import { render, staticRenderFns } from "./ButtonPicture.vue?vue&type=template&id=62c6e730&scoped=true&"
import script from "./ButtonPicture.vue?vue&type=script&lang=js&"
export * from "./ButtonPicture.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPicture.vue?vue&type=style&index=0&id=62c6e730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6e730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c6e730')) {
      api.createRecord('62c6e730', component.options)
    } else {
      api.reload('62c6e730', component.options)
    }
    module.hot.accept("./ButtonPicture.vue?vue&type=template&id=62c6e730&scoped=true&", function () {
      api.rerender('62c6e730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/ButtonPicture.vue"
export default component.exports